import { useEffect, useState } from "react";
import { RefreshCcw } from "lucide-react";
import { toast } from "sonner";
import { api, fmtErr } from "@/lib/api";

export default function AdminIntegrationsTab() {
  const [items, setItems] = useState(null);
  const load = async () => {
    try { const { data } = await api.get("/admin/integrations"); setItems(data); }
    catch (e) { toast.error(fmtErr(e)); }
  };
  useEffect(() => { load(); }, []);

  const backfill = async () => {
    try {
      const { data } = await api.post("/admin/integrations/sheets/backfill");
      data.active ? toast.success(data.message) : toast.info(data.message);
    } catch (e) { toast.error(fmtErr(e)); }
  };

  if (!items) return <p className="text-zinc-500 text-xs uppercase tracking-[0.25em] animate-pulse">Checking integrations…</p>;
  return (
    <div data-testid="admin-integrations">
      <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-px bg-zinc-800 border border-zinc-800">
        {Object.entries(items).map(([key, item]) => (
          <div key={key} data-testid={`integration-${key}`} className="bg-zinc-950 p-6">
            <p className={`font-display text-4xl ${item.active ? "text-volt" : "text-zinc-600"}`}>{item.active ? "ON" : "OFF"}</p>
            <p className="mt-2 text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-bold">{item.label}</p>
          </div>
        ))}
      </div>
      <div className="mt-4 border border-zinc-800 bg-zinc-950 p-6 flex flex-wrap items-center justify-between gap-4">
        <div>
          <h3 className="font-display uppercase text-3xl">Google Sheets</h3>
          <p className="text-sm text-zinc-500 mt-2">Backfill every onboarded member and assessment lead. Sync activates after the service-account credential is configured.</p>
        </div>
        <button data-testid="admin-sheets-backfill" onClick={backfill}
          className="inline-flex items-center gap-2 border border-volt text-volt px-5 py-3 text-xs uppercase tracking-[0.14em] font-bold hover:bg-volt hover:text-black transition-colors">
          <RefreshCcw size={14} /> Run backfill
        </button>
      </div>
    </div>
  );
}
